import { render, staticRenderFns } from "./postCategories.vue?vue&type=template&id=c14c33e6&"
import script from "./postCategories.vue?vue&type=script&lang=js&"
export * from "./postCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports